import { render, staticRenderFns } from "./emolument-report.vue?vue&type=template&id=5b028e23"
import script from "./emolument-report.vue?vue&type=script&lang=js"
export * from "./emolument-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports